import { useRef, type ReactNode } from 'react';
import { usePageScrollPassthrough } from '../../hooks/usePageScrollPassthrough';

interface ControlCentreActivityLogShellProps {
  children: ReactNode;
}

/**
 * Control-centre content wrapper. The activity log used to live in a
 * right-edge slide-out rail owned by this shell; it now opens as a
 * full-screen modal from the hero's Activity button, so the shell is just
 * the padded scroll container.
 */
export default function ControlCentreActivityLogShell({ children }: ControlCentreActivityLogShellProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  usePageScrollPassthrough(contentRef);

  return (
    <div
      ref={contentRef}
      className="control-centre pt-3 pb-8 px-3 md:pt-4 md:pb-8 md:px-4 w-full max-w-none"
    >
      {children}
    </div>
  );
}
